'use client'
import React, { useEffect, useRef } from 'react'
import logo from '@/assets/images/brand-logo.svg'
import logoIcon from '@/assets/images/logo-icon.svg'
import HeaderMenu from '@/shared/components/header/headerMenu'
import MyImage from '@/shared/components/myImage'
import CustomLink from '@/shared/components/customLink'
import SearchModal from '../search-modal'
import MobileMenu from '../../mobileMenu'

function HeaderWrapperMain({ webMenu }: any) {
  const headerRef = useRef<any>(null)

  useEffect(() => {
    const handleScroll = () => {
      const headerElement = headerRef.current
      if (!headerElement) return

      if (window.scrollY > 0) {
        headerElement.classList.add('shadow-HeaderShadow')
      } else {
        headerElement.classList.remove('shadow-HeaderShadow')
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  return (
    <div ref={headerRef} className='bg-headerFooter sticky top-0 z-50'>
      <header className='container h-12 md:h-16'>
        <div className='flex items-center h-full w-full'>
          <div className='flex items-center h-full'>
            <CustomLink prefetch={false} className={`mr-3 p-0 block`} href='/'>
              <MyImage
                className='w-6 md:w-8 max-w-none'
                src={logoIcon}
                placeholderImage={logoIcon}
                alt='logo'
              />
            </CustomLink>
            <CustomLink prefetch={false} className={`md:mr-16 p-0`} href='/'>
              <MyImage
                className='w-40 md:w-52 max-w-none dark:brightness-0 invert-[1]'
                src={logo}
                placeholderImage={logo}
                alt='logo'
              />
            </CustomLink>
          </div>
          <div className='h-full md:block hidden'>
            <HeaderMenu headerData={webMenu} />
          </div>

          <SearchModal />
        </div>
      </header>
      {/* <div className='w-full my-2 scroll-list flex md:hidden'>
        <HeaderMenu headerData={mobData} />
      </div> */}
      <MobileMenu />
    </div>
  )
}

export default HeaderWrapperMain
